import { generateTranslations } from '../../i18n/translation';

const namespace = 'addStudiestedbruker';

const translations = generateTranslations(namespace, {
  title: {
    nb: 'Lag studiestedbruker ved en institusjon',
    en: 'Generate UH user at an institution',
  },
  subtitle: {
    nb: 'Lag en ny studiestedbruker med din feideId ved en institusjon du ikke har bruker fra før.',
    en: 'Generate an UH user with your feideId at an institution you are not currently affiliated with.',
  },
  institutionLabel: {
    nb: 'Institusjoner',
    en: 'Institutions',
  },
  btnText: {
    nb: 'Lag ny bruker',
    en: 'Generate new user',
  },
  successMsg: {
    nb: 'Bruker lagt til for din feideId',
    en: 'User added for your feideId',
  },
  placeholder: {
    nb: 'Velg institusjon',
    en: 'Choose institution',
  },
});

export default translations;
